import moment from 'moment';

export const required = value => (value ? undefined : 'Required');

// (value != null  ? undefined : 'Required')

export const requiredDropdown = (value) => {
  if (isEmpty(value)) return undefined;
  if (Array.isArray(value) && value.length === 0) {
    return 'Required';
  } else {
    return undefined;
  }
};

export const dateValidation = (value) => {
  if (isEmpty(value)) return undefined;
  return (value && moment(value).isValid()) || value === '' ? undefined : 'Invalid date';
}

export const maxLength = (max, message) => (value) => {
  if (isEmpty(value)) return undefined;
  const errorMsg = message ? message : `Must be ${max} characters or less`;
  return value && value.length > max ? errorMsg : undefined;
}

export const letters = value => value && !/^[A-Z._-\s]+$/i.test(value) ? 'Must be letters' : undefined;

export const number = (value) => {
  if (isEmpty(value)) return undefined;
  return value && isNaN(Number(value)) ? 'Must be a number' : undefined;
}

export const maxPinLength = (value) => {
  if (isEmpty(value)) return undefined;
  return value && value.length !== 4 ? 'Register Pin must be 4 characters' : undefined;
}

export const wholeNumberInteger = (value) => {
  return value && !/^\d+$/i.test(value) ?
    'Must be a whole number' : undefined;
}

export const minValue = (min) => (value) => {
  if (isEmpty(value)) return undefined;
  return value && value < min ? `Must be at least ${min}` : undefined;
}

export const maxValue = (max) => (value) => {
  if (isEmpty(value)) return undefined;
  return value && value > max ? `Must be less than ${max}` : undefined;
}


export const maxDate = (max) => (value) => {
  const maxDate = moment(max);

  if (isEmpty(value) || !maxDate.isValid() || isEmpty(max)) return undefined;
  return (moment(value).isSameOrBefore(moment(max))) ? undefined : `Must be less than ${maxDate.format('LL')}`;
}


export const minDate = (min) => (value) => {
  const minDate = moment(min);

  if (isEmpty(value) || !minDate.isValid() || isEmpty(min)) return undefined;
  return (moment(value).isSameOrAfter(minDate)) ? undefined : `Must be greater than ${minDate.format('LL')}`;
}


export const email = (value) => {
  if (isEmpty(value)) return undefined;
  return value && !/\S+@\S+\.\S+$/i.test(value) ?
    'Invalid email address' : undefined;
}

export const multiEmail = (value) => {
  if (isEmpty(value)) return undefined;

  const emails = value.split(',');
  const wrongEmails = [];

  (emails || []).forEach(email => {
    if (email && !/\S+@\S+\.\S+$/i.test(email)) {
      wrongEmails.push(email);
    };
  });

  if (wrongEmails.length === 0) return undefined;
  return `Invalid email addresses: ${wrongEmails.join(',')}`;
}

export const url = (value) => {
  if (isEmpty(value)) return undefined;
  return value && !/^(ftp|http|https):\/\/[^ ']+$/.test(value) ?
    'Must be a valid URL' : undefined;
}

export const personName = (value) => {
  if (isEmpty(value)) return undefined;
  return value => value && !/^[A-Z._-\s]+$/i.test(value) ?
    'Invalid name' : undefined;
}

export const minSelected = (min = 0) => (value) => {
  if (isEmpty(value)) return undefined;
  if (Array.isArray(value) && value.length < min) return 'Required';
  return undefined;
};


function isEmpty(value) {
  return value == null || value === '';
}

export function isActive(fromDate, toDate) {
  const day1 = new Date(fromDate);
  const day2 = new Date(toDate);
  const today = new Date();
  if (day2 instanceof Date && isFinite(day2)) {
    // check if today is between from and to dates
    if (today > day1 && today < day2) {
      return true;
    }
    return false;
  }
  // no toDate, then active is true
  return true;
}

export const percentage = (value) => {
  return ((value >= 0 && value <= 100) || value === null) ? undefined : "Must be 0 to 100"
}
